import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';
import { CardContent, CardMedia } from '@mui/material';

import { Book } from 'api/book/model';
import { Card, Title } from 'common';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

import { useLanguage } from '../../../context/LanguageContext'

interface BookCardProps {
    bookItem: Book;
}

export const BookCard = ({ bookItem }: BookCardProps) => {
    const { language } = useLanguage();

    return (
        <Link to={`/book-club/${bookItem.id}`} style={{ textDecoration: 'none' }}>
            <Card sx={{ maxWidth: 345, marginBottom: 2, border: '1px solid #af0000' }}>
                {bookItem.images && bookItem.images.length > 0 && bookItem.images[0] ? (
                    <CardMedia
                        component="img"
                        height="200"
                        sx={{ borderRadius: 1 }}
                        image={bookItem.images[0].photo}
                        alt={bookItem.title}
                    />
                ) : (
                    <ImageNotSupportedIcon
                        sx={{
                            height: 200,
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '5rem'
                        }}
                    />
                )}
                <CardContent>
                    <Title
                        gutterBottom
                        variant="h5"
                        component="div"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2, // количество строк, для отображения
                            fontWeight: 600,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {bookItem[`title_${language}`]}
                    </Title>
                    <Title
                        gutterBottom
                        variant="body1"
                        color="text.secondary"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 4, // количество строк, для отображения
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        <div dangerouslySetInnerHTML={{
                            __html: bookItem[`description_${language}`]
                        }} />
                    </Title>
                    <Title variant="body2" color="text.primary">
                        {dayjs(bookItem.created_at).format('DD.MM.YYYY')}
                    </Title>
                </CardContent>
            </Card>
        </Link>
    );
};
